import React, { useMemo } from "react";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: CallSignCellContent.Props["item"]) =>
	item.callSign;

const CallSignCellContent: React.FC<CallSignCellContent.Props> = ({ item }) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CallSignCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default CallSignCellContent;
